/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "assets/img/jpg (1).jpg";
import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";

export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminId");
    navigate("/auth/login");
  };

  const [collapseShow, setCollapseShow] = useState("hidden");
  const [cityMenuOpen, setCityMenuOpen] = useState(false);
  const [ratecardMenuOpen, setRatecardMenuOpen] = useState(false);
  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);
  const [subscriptionMenuOpen, setSubscriptionMenuOpen] = useState(false);
  const [useAppMenuOpen, setUseAppMenuOpen] = useState(false);
  const [notificationMenuOpen, setNotificationMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setCollapseShow(""); // Keep sidebar open on desktop
      } else {
        setCollapseShow("hidden"); // Collapse sidebar on mobile
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleCollapse = () => {
    setCollapseShow(collapseShow === "hidden" ? "bg-white m-2 py-3 px-6" : "hidden");
  };

  const toggleCityMenu = () => setCityMenuOpen(!cityMenuOpen);
  const toggleRatecardMenu = () => setRatecardMenuOpen(!ratecardMenuOpen);
  const toggleCategoryMenu = () => setCategoryMenuOpen(!categoryMenuOpen);
  const toggleServiceMenu = () => setServiceMenuOpen(!serviceMenuOpen);
  const toggleNotificationMenu = () => setNotificationMenuOpen(!notificationMenuOpen);
  const toggleSubscriptionMenu = () => setSubscriptionMenuOpen(!subscriptionMenuOpen);
  const toggleUseAppMenu = () => setUseAppMenuOpen(!useAppMenuOpen);

  // Close sidebar on mobile when a link is clicked or toggle is clicked
  const handleLinkClick = () => {
    if (isMobile) {
      setCollapseShow("hidden");
    }
  };

  return (
    <>
      <nav
        className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6 transition-all duration-300"
        style={{
          backgroundColor: collapseShow === "hidden" ? "transparent" : "#ffffff",
        }}
      >
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={toggleCollapse}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <img
              src={logo}
              alt="VisitGuru Logo"
              className="h-16 mb-2 mx-auto md:mx-0"
            />
          </Link>
          {/* User */}
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
            style={{
              display: collapseShow === "hidden" ? "none" : "block",
              backgroundColor: "#ffffff",
              transition: "all 0.3s ease",
            }}
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    VisitGuru
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={toggleCollapse}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}
            <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 px-3 py-2 h-12 border border-solid border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
            </form>

            {/* Divider */}
            <hr className="my-4 md:min-w-full" />
            {/* Heading */}
            <h6 className="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              Admin Layout Pages
            </h6>
            {/* Navigation */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/dashboard") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/dashboard"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Dashboard
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/employee") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/employee"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-user-tie mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/employee") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Employee
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/vendor") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/vendor"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-users mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/vendor") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Vendors
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/user") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/user"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-user mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/user") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Customers
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/booking") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/booking"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-book mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/booking") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Booking
                </Link>
              </li>

              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleServiceMenu}
                >
                  <i className="fas fa-toolbox mr-2 text-sm text-blueGray-300"></i>
                  Service
                </span>
                {serviceMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/addservice")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/addservice"
                        onClick={handleLinkClick}
                      >
                        Add Service
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/service")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/service"
                        onClick={handleLinkClick}
                      >
                        Get Service
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/admin/contact") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/admin/contact"
                  onClick={handleLinkClick}
                >
                  <i
                    className={
                      "fas fa-address-card mr-2 text-sm " +
                      (window.location.href.indexOf("/admin/contact") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Help & Support
                </Link>
              </li>
              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleCategoryMenu}
                >
                  <i className="fas fa-list mr-2 text-sm text-blueGray-300"></i>
                  Category
                </span>
                {categoryMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/addcategory")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/addcategory"
                        onClick={handleLinkClick}
                      >
                        Add Category
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/category")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/category"
                        onClick={handleLinkClick}
                      >
                        Get Category
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleRatecardMenu}
                >
                  <i className="fas fa-check mr-2 text-sm text-blueGray-300"></i>{" "}
                  Rate card
                </span>
                {ratecardMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/addratecard")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/addratecard"
                        onClick={handleLinkClick}
                      >
                        Add RateCard
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/ratecard")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/ratecard"
                        onClick={handleLinkClick}
                      >
                        Get RateCard
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleCityMenu}
                >
                  <i className="fas fa-city mr-2 text-sm text-blueGray-300"></i>{" "}
                  City
                </span>
                {cityMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/addcity")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/addcity"
                        onClick={handleLinkClick}
                      >
                        Add City
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/city")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/city"
                        onClick={handleLinkClick}
                      >
                        Get City
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <Link
                  className={`text-xs uppercase py-3 font-bold block text-blueGray-500 ${window.location.href.includes("/admin/poster")
                    ? "text-lightBlue-500"
                    : "text-blueGray-700 hover:text-blueGray-500"
                    }`}
                  to="/admin/poster"
                  onClick={handleLinkClick}
                >
                  <i className="fas fa-file-image mr-2 text-sm text-blueGray-300"></i>{" "}
                  Poster
                </Link>
              </li>

              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleNotificationMenu}
                >
                  <i className="fas fa-bell mr-2 text-sm text-blueGray-300"></i>{" "}
                  Notifications
                </span>
                {notificationMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/notifications")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/notifications"
                        onClick={handleLinkClick}
                      >
                        📤 Send Notification
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/notificationhistory")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/notificationhistory"
                        onClick={handleLinkClick}
                      >
                        💬 Notification History
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li className="items-center">
                <span
                  className="text-xs uppercase py-3 font-bold block cursor-pointer"
                  onClick={toggleSubscriptionMenu}
                >
                  <i className="fas fa-star mr-2 text-sm text-blueGray-300"></i>{" "}
                  Subscription
                </span>
                {subscriptionMenuOpen && (
                  <ul className="ml-4">
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/subscription")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/subscription"
                        onClick={handleLinkClick}
                      >
                        📜 Subscription History
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/addsubscription")
                          ? "text-lightBlue-500"
                          : "text-blueGray-700 hover:text-blueGray-500"
                          }`}
                        to="/admin/addsubscription"
                        onClick={handleLinkClick}
                      >
                        📝 Update Subscription
                      </Link>
                    </li>
                  </ul>
                )}
                <li className="items-center">
                  <span
                    className="text-xs uppercase py-3 font-bold block cursor-pointer"
                    onClick={toggleUseAppMenu}
                  >
                    <i className="fas fa-book-open mr-2 text-sm text-blueGray-300"></i>{" "}
                    How to Use App
                  </span>
                  {useAppMenuOpen && (
                    <ul className="ml-4">
                      <li>
                        <Link
                          className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/useAppVendor")
                            ? "text-lightBlue-500"
                            : "text-blueGray-700 hover:text-blueGray-500"
                            }`}
                          to="/admin/useApp"
                          onClick={handleLinkClick}
                        >
                          🧑‍💼 Vendor
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={`text-xs uppercase py-3 font-bold block ${window.location.href.includes("/admin/useAppEmployee")
                            ? "text-lightBlue-500"
                            : "text-blueGray-700 hover:text-blueGray-500"
                            }`}
                          to="/admin/useAppEmployee"
                          onClick={handleLinkClick}
                        >
                          👨‍🔧 Employee
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}